import { useSelector } from "react-redux"

const SUPER_ADMIN_ROLE_IDS = [1, 51]

/**
 * Whether the logged-in user is a super admin. The role-id check is inlined in a lot of places;
 * this keeps the ids in one spot for the callers that need it.
 */
const useIsSuperAdmin = () => {
    const {
        loginData: { user_data },
    } = useSelector((store: any) => store.verifyLogin)

    return SUPER_ADMIN_ROLE_IDS.includes(user_data?.role_id)
}

export default useIsSuperAdmin
